import {
  PaymentMethod as ApiPaymentMethod,
  PaymentMethodListResponse as ApiPaymentMethodListResponse,
  PaymentMethodSetupResponse as ApiPaymentMethodSetupResponse,
} from '@/gen/api';
import { PaymentMethod, PaymentMethods, PaymentMethodSetup } from '@/models/PaymentMethod';

export const toPaymentMethod = (apiPaymentMethod: ApiPaymentMethod): PaymentMethod => {
  return {
    ...apiPaymentMethod,
  };
};

export const toPaymentMethods = (
  apiPaymentMethodListResponse: ApiPaymentMethodListResponse,
): PaymentMethods => {
  return {
    ...apiPaymentMethodListResponse,
    items: apiPaymentMethodListResponse.items.map(toPaymentMethod),
  };
};

export const toPaymentMethodSetup = (
  apiPaymentMethodSetupResponse: ApiPaymentMethodSetupResponse,
): PaymentMethodSetup => {
  return {
    ...apiPaymentMethodSetupResponse,
  };
};
